var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=WorkPlanning, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10C4 9.44772 4.44772 9 5 9H23C23.5523 9 24 9.44772 24 10V18C24 18.5523 23.5523 19 23 19H5C4.44772 19 4 18.5523 4 18V10ZM4 32C4 31.4477 4.44772 31 5 31H23C23.5523 31 24 31.4477 24 32V40C24 40.5523 23.5523 41 23 41H5C4.44772 41 4 40.5523 4 40V32ZM15 21V23C15 23.5128 15.386 23.9355 15.8834 23.9933L16 24H20V21.9231L25 25L20 28.0769V26H16C14.4023 26 13.0963 24.7511 13.0051 23.1763L13 23V21H15Z",
    fill: "#E0E4E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 20C26.4477 20 26 20.4477 26 21V29C26 29.5523 26.4477 30 27 30H45C45.5523 30 46 29.5523 46 29V21C46 20.4477 45.5523 20 45 20H27ZM35 32V34C35 34.5128 34.614 34.9355 34.1166 34.9933L34 35H30V32.9231L25 36L30 39.0769V37H34C35.5977 37 36.9037 35.7511 36.9949 34.1763L37 34V32H35Z",
    fill: "#C3CBD3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.f82810a58fdf00d32b56a1da97dcec3d.svg";
export { ForwardRef as ReactComponent };